import { memo } from 'react';
import { Title1, Title2, Regular, Support } from './styles';

const variants = {
  title1: Title1,
  title2: Title2,
  regular: Regular,
  support: Support,
};

const Text = ({ text, children, component = undefined, variant = null, ...props }) => {
  const ComponentForRendering = component || variants[variant] || 'p';
  return (
    <ComponentForRendering {...props}>
      {text || children}
    </ComponentForRendering>
  )
}

export default memo(Text);
